import moment from 'moment';
import { useState } from 'react';
import Switch from "react-switch";
import useClickOutside from '../../../../useClickOutside';
import assign from '../../../../assets/images/assignment.png'

export const ColumnProducts = (translate, warning,langLocal,detailOfProduct,setOpenEdit,setIdEdit,setOpenAssign) => {
    const [options, setOptions] = useState(false)
    const [row_id, setRowId] = useState(null)
    let domNode = useClickOutside(() => {
        setOptions(false);
        setRowId(null)
    });
    const columns = [
        {
            name: <span className="color_spann">{translate('id')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['id']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('name')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['name']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('warehouse')}</span>, sortable: true,
            cell: (row) => (
                <span>{row?.warehouse?.name}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('category')}</span>,
            cell: (row) => (
                <span>{row?.material_category?.name}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('type')}</span>,
            cell: (row) => (
                <span>{row['type']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('assign')}</span>,
            cell: (row) => (
                <img onClick={()=>{
                    setOpenAssign(true);setIdEdit(row?.id)
                }} style={langLocal === "en"? {marginLeft: "10px"}:{marginRight: "10px"}} 
                className={`stats-icon ${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"}`} src={assign} />
            )
        },
        {
            name: <span className="color_spann">{translate('actions')}</span>,
            cell: (row,index) => (
                <div  >
                    {/*<i className='fa fa-edit icon_edit' onClick={(e) => handleEdit(e, row)} ></i>
                    <i className='fa fa-trash icon_trash' onClick={() => warning(row)} ></i>*/}
                    <i className='fa fa-ellipsis-v icon_edit' onClick={() => {setOptions(!options);setRowId(index)}}  ></i>
                    {
                        options && index === row_id && (
                            <div  ref={domNode} className='div-actions shadow_main' style={langLocal === 'ar' ? { left: '20px' } : { left: '-100px' }} >
                                <span onClick={()=> {setOpenEdit(true);setIdEdit(row?.id)}} >{translate('edit')}</span>
                                <span onClick={() => warning(row)} >{translate('delete')}</span>
                                <span onClick={()=> detailOfProduct(row?.id)} >{translate('details')}</span>
                            </div>
                        )
                    }
                </div>
            )
        }
    ]
    return {
        columns
    }
}
function SwitchComponent({ checked, onChange }) {
    return (
        <Switch
            onColor='#756bc1'
            checkedIcon={false}
            uncheckedIcon={false}
            height={20}
            width={40}
            handleDiameter={15}
            checked={checked}
            onChange={onChange}
        />
    );
}